/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

export class DetailsOptions {
  public modelApi: string;
  public dataApi: string;
  public display: 'list' | 'table';
  public zoomKey: string;
  public paginationStep = 20;
  public rowHeight: 'S' | 'M' | 'L' = 'M';

  constructor(
    modelApi: string,
    dataApi: string,
    display: 'list' | 'table' = 'list'
  ) {
    this.modelApi = modelApi;
    this.dataApi = dataApi;
    this.display = display;
  }
}
